import React, { useEffect, useState } from 'react';
import ButtonComp from '../ButtonComp/ButtonComp';
import { Modal, Popconfirm, Spin } from 'antd';

import { SwapOutlined, RedoOutlined } from "@ant-design/icons"
import { Table, Tag } from 'antd';
import "./Table.css";
import { trash, edit } from '../../Utils/imports';
import AddUserModal from '../Modaluser/AddUserModal';
import NewValidation from '../Modaluser/newValidation';
import { useDispatch, useSelector } from 'react-redux';
import { getRolesList } from '../../API-Interaction/apiServices/roles.api';
import { error } from '../../Helpers/notification'
import { onDeleteUserSubmit } from '../../API-Interaction/apiServices/plantSettings.api';
import { antIcon, getFromLocalStorage, isSuperAdminByEmail } from '../../Helpers/helpers';
import { setPageLoader } from '../../Redux/features/utils.slice';
import { CustomUserTableColumn } from '../../Utils/constants';


const CustomUserTable = () => {

    let dispatch = useDispatch()

    let { current = null } = useSelector(state => state?.plant)
    let { lines = null } = useSelector(state => state?.plant?.lists)
    let { username } = getFromLocalStorage('user')
    const { pageLoaders } = useSelector(state => state?.utils.loaders)
    let { plant = null } = useSelector(state => state?.plant?.current)
    const accessControl = plant?.accessControl
    const [openUserModal, setOpenUserModal] = useState(false);
    const [openValidationModal, setOpenValidationModal] = useState(false)
    const [type, setType] = useState({ value: "", key: null })

    // key 1 for User Modal 
    // key 2 for Validation Modal
    const openModal = (key) => {
        if (key === 1) setOpenUserModal(true)
        if (key === 2) setOpenValidationModal(true)
    }
    const closeModal = (key) => {
        console.log('Here', key)
        if (key === 1) setOpenUserModal(false)
        if (key === 2) setOpenValidationModal(false)
    }



    const onDeleteUser = (record) => {
        let { plant = null } = current;
        let email = username;
        if (record.email === email) {
            error('Please sign in from another user to delete.')
            return
        }
        const accessControl = plant?.accessControl.filter(item => item.email !== record.email)

        let updateAC = {
            accessControl,
            _id: plant?._id
        }
        onDeleteUserSubmit(dispatch, updateAC)
    }

    const Tableuser = [
        {
            title: 'Email Address',
            dataIndex: 'email',
            render: (text, record) => text
        },
        {
            title: 'Role',
            dataIndex: 'role',
        },
        {
            title: 'Line',
            dataIndex: 'lines',
            render: (text, record) => <>
                {record.lines && record.lines.reduce((total, line) => {
                    const dbDocumentFound = lines.find(userline => line.id === userline.id);
                    if (dbDocumentFound) {
                        return total.concat({
                            ...line,
                            ...dbDocumentFound,
                        });
                    }
                    return total;
                }, []).map(line => <Tag key={line.id}>{line.lineName}</Tag>)}
            </>
        },

        {
            title: 'Actions',
            dataIndex: "action",
            render: (text, record) =>
                <>
                    <img src={edit} onClick={() => { openModal(1); setType({ value: record.email, key: 3 }) }} style={{ width: "20px", cursor: "pointer", marginRight: "20px" }} />
                    <Popconfirm placement="topRight" okText="Delete" cancelText="Cancel" okButtonProps={{className: "popRed"}} cancelButtonProps={{className: "popBlue"}} title="Confirm delete ?" onConfirm={() => { onDeleteUser(record) }}>
                        <img src={trash} style={{ width: "20px", cursor: "pointer" }} />
                    </Popconfirm>
                </>
        },
    ];

    return (
        <div className='dflex flexColumn gap20 pt1'>
            <div className='lineOp_head dflex alignCenter justifySB'>
                <h1 className='pageHead'>Users</h1>
                <div className='dflex alignCenter justifyCenter gap10'>
                    {/* Add User Modal */}
                    <ButtonComp onClick={() => { openModal(1); setType({value:"",key:1}) }} theme={"white"} text="Add Users" icon={<SwapOutlined />} />
                    <Modal maskClosable={false} title={<h2>{`${type.key === 3 ? "Edit User" : "Add User"}`}</h2>} className='modaladduser' footer={null} open={openUserModal} onOk={() => openModal(1)} onCancel={() => closeModal(1)}>
                        <AddUserModal closeModal={closeModal} type={type} />
                    </Modal>

                    {/* Add Validation Modal */}
                    {isSuperAdminByEmail(username) && (
                    <ButtonComp onClick={() => openModal(2)} theme={"blue"} text="Add Validation" icon={<RedoOutlined />} />
                     )} 
                    <Modal maskClosable={false} title={<h2>Add validation</h2>} className='modaladduser' footer={null} open={openValidationModal} onOk={() => openModal(2)} onCancel={() => closeModal(2)}>
                        <NewValidation closeModal={closeModal} />
                    </Modal>
                </div>
            </div>
            <div className='lineOp_tale'>
                <Spin indicator={antIcon} spinning={pageLoaders?.deleteUser || pageLoaders?.addUser || pageLoaders?.editUser|| false}>
                    <Table columns={Tableuser} dataSource={current?.plant?.accessControl} />
                </Spin>
            </div>
        </div>
    )

}
export default CustomUserTable;